// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file device/device_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Device_Status } from './device_model_pb';
import { file_device_device_model } from './device_model_pb';

/**
 * Describes the file device/device_request.proto.
 */
export const file_device_device_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChtkZXZpY2UvZGV2aWNlX3JlcXVlc3QucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IhMKEUdldERldmljZXNSZXF1ZXN0IhkKF0dldEN1cnJlbnREZXZpY2VSZXF1ZXN0IjAKF1Rlcm1pbmF0ZURldmljZXNSZXF1ZXN0EhEKCWRldmljZUlkcxgBIAMoCToCGAEiYAoWU2V0RGV2aWNlU3RhdHVzUmVxdWVzdBIRCglkZXZpY2VJZHMYASADKAkSMwoGc3RhdHVzGAIgASgOMiMuY29tLmdlbS5iZmYuY29udHJhY3QuRGV2aWNlLlN0YXR1c0IYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_device_device_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetDevicesRequest
 */
export type GetDevicesRequest = Message<'com.gem.bff.contract.GetDevicesRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetDevicesRequest.
 * Use `create(GetDevicesRequestSchema)` to create a new message.
 */
export const GetDevicesRequestSchema: GenMessage<GetDevicesRequest> =
  /*@__PURE__*/
  messageDesc(file_device_device_request, 0);

/**
 * @generated from message com.gem.bff.contract.GetCurrentDeviceRequest
 */
export type GetCurrentDeviceRequest = Message<'com.gem.bff.contract.GetCurrentDeviceRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetCurrentDeviceRequest.
 * Use `create(GetCurrentDeviceRequestSchema)` to create a new message.
 */
export const GetCurrentDeviceRequestSchema: GenMessage<GetCurrentDeviceRequest> =
  /*@__PURE__*/
  messageDesc(file_device_device_request, 1);

/**
 * Deprecated: use SetDeviceStatusRequest(DELETED) instead
 *
 * @generated from message com.gem.bff.contract.TerminateDevicesRequest
 * @deprecated
 */
export type TerminateDevicesRequest = Message<'com.gem.bff.contract.TerminateDevicesRequest'> & {
  /**
   * @generated from field: repeated string deviceIds = 1;
   */
  deviceIds: string[];
};

/**
 * Describes the message com.gem.bff.contract.TerminateDevicesRequest.
 * Use `create(TerminateDevicesRequestSchema)` to create a new message.
 * @deprecated
 */
export const TerminateDevicesRequestSchema: GenMessage<TerminateDevicesRequest> =
  /*@__PURE__*/
  messageDesc(file_device_device_request, 2);

/**
 * @generated from message com.gem.bff.contract.SetDeviceStatusRequest
 */
export type SetDeviceStatusRequest = Message<'com.gem.bff.contract.SetDeviceStatusRequest'> & {
  /**
   * @generated from field: repeated string deviceIds = 1;
   */
  deviceIds: string[];

  /**
   * @generated from field: com.gem.bff.contract.Device.Status status = 2;
   */
  status: Device_Status;
};

/**
 * Describes the message com.gem.bff.contract.SetDeviceStatusRequest.
 * Use `create(SetDeviceStatusRequestSchema)` to create a new message.
 */
export const SetDeviceStatusRequestSchema: GenMessage<SetDeviceStatusRequest> =
  /*@__PURE__*/
  messageDesc(file_device_device_request, 3);
